/* eslint-disable */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import {
  Table,
  Tabs,
  Button,
  Space,
  Typography,
  Modal,
  message,
  Image,
  Popconfirm,
  Pagination,
  Tag,
} from 'antd';
import '../../components/mobile-order/MobileOrder.css';
import MobileOrderCard from '../../components/mobile-order/MobileOrderCard';
import MobileProductItem from '../../components/mobile-order/MobileProductItem';
import {
  ReloadOutlined,
  EyeOutlined,
  FileImageOutlined,
  FileTextOutlined,
  CreditCardOutlined,
  ShoppingCartOutlined,
  DollarOutlined,
  EnvironmentOutlined,
} from '@ant-design/icons';
import InfoCard, { InfoRow, InfoGrid } from '../../components/info-card/InfoCard';

dayjs.extend(buddhistEra);
dayjs.locale('th');

const { Title, Text } = Typography;

const formatCurrency = (val) =>
  Number(val || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });

const getPaymentMethodText = (method) => {
  const methodMap = {
    cash: 'ชำระแบบ โอนเงิน',
    promtpay: 'ชำระแบบ PromtPay',
    creditcard: 'ชำระแบบ บัตรเครดิต/บัตรเดบิต',
  };
  return methodMap[method] || 'ไม่ทราบ';
};

const renderShopInfo = (shopName, province) => (
  <Space direction='vertical' size={0}>
    <Text strong>{shopName}</Text>
    <Text type='secondary' style={{ fontSize: '12px' }}>
      {province}
    </Text>
  </Space>
);

const renderCurrency = (val) => formatCurrency(val);
const renderCurrencyBold = (val) => (
  <Text strong type='success'>
    {formatCurrency(val)}
  </Text>
);

const productItemColumns = [
  { title: 'หน่วย', dataIndex: 'unit', render: (val) => `ชุด ${val} ชิ้น` },
  { title: 'วันหมดอายุ', dataIndex: 'expire', render: (val) => dayjs(val).format('DD MMM BBBB') },
  { title: 'จำนวน', dataIndex: 'select', render: (val) => `x ${val}` },
  {
    title: 'ยอดรวม',
    dataIndex: 'subtotal',
    align: 'right',
    render: (val) => `฿ ${Number(val).toLocaleString()}`,
  },
];

const OrderPaySlip = (props) => {
  const [loading, setLoading] = useState(false);
  const [payslipList, setPayslipList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [orderGroup, setOrderGroup] = useState([]);

  const [activeTab, setActiveTab] = useState('pending');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPayment, setCurrentPayment] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);

  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);

  useEffect(() => {
    fetchPaySlipList();
  }, [activeTab]);

  useEffect(() => {
    if (orderList.length > 0) {
      const unique = orderList.filter(
        (obj, index) => orderList.findIndex((item) => item.payment_id === obj.payment_id) === index,
      );
      setOrderGroup(unique);
    } else {
      setOrderGroup([]);
    }
  }, [orderList]);

  const fetchPaySlipList = async () => {
    setLoading(true);

    try {
      const formData = new FormData();
      if (activeTab === 'history') {
        formData.append('status', 'processed');
      }

      const response = await axios.post(
        `${props.app_hostname}/api/order/admin/slip/getall`,
        formData,
        { headers: { Authorization: `Bearer ${props.permitdata.token}` } },
      );

      if (response.data.status === 'OK') {
        setPayslipList(response.data.payslip);
      } else {
        message.error(response.data.message || 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderData = async (payment) => {
    setModalLoading(true);
    setCurrentPayment(payment);

    try {
      const formData = new FormData();
      formData.append('payment_id', payment.payment_id);

      const response = await axios.post(
        `${props.app_hostname}/api/order/admin/slip/getorderbypayment`,
        formData,
        { headers: { Authorization: `Bearer ${props.permitdata.token}` } },
      );

      if (response.data.status === 'OK') {
        setOrderList(response.data.order);
        setIsModalOpen(true);
      } else {
        message.error(response.data.message || 'ไม่พบข้อมูลคำสั่งซื้อ');
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setModalLoading(false);
    }
  };

  const fetchSlipImages = async (payment) => {
    setModalLoading(true);

    try {
      const formData = new FormData();
      formData.append('payment_id', payment.payment_id);

      const response = await axios.post(
        `${props.app_hostname}/api/order/admin/slip/getimage`,
        formData,
        { headers: { Authorization: `Bearer ${props.permitdata.token}` } },
      );

      if (response.data.status === 'OK') {
        if (response.data.files && response.data.files.length > 0) {
          setGalleryImages(response.data.files.map((f) => f.original));
          setIsGalleryOpen(true);
        } else {
          message.warning('ไม่พบไฟล์สลิป');
        }
      } else {
        message.error(response.data.message || 'เกิดข้อผิดพลาด');
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setModalLoading(false);
    }
  };

  const handleCashReceive = async () => {
    if (!currentPayment) return;

    setModalLoading(true);

    try {
      const formData = new FormData();
      formData.append('payment_id', currentPayment.payment_id);

      const shoplist = [];
      let buyer = '';
      orderList.forEach((order) => {
        if (order.payment_id === currentPayment.payment_id) {
          shoplist.push(order.seller_shopid);
          buyer = order.buyer_shopid;
        }
      });
      formData.append('shoplist', shoplist.join('##'));
      formData.append('buyer', buyer);

      const response = await axios.post(
        `${props.app_hostname}/api/order/admin/slip/cashrecieve`,
        formData,
        { headers: { Authorization: `Bearer ${props.permitdata.token}` } },
      );

      if (response.data.status === 'OK') {
        message.success('บันทึกการชำระเงินสำเร็จ');
        setIsModalOpen(false);

        if (response.data.reload) {
          setPayslipList((prev) =>
            prev.filter((item) => item.payment_id !== response.data.payment_id),
          );
        } else {
          fetchPaySlipList();
        }
      } else {
        message.error(response.data.message || 'เกิดข้อผิดพลาด');
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setModalLoading(false);
    }
  };

  const columns = [
    {
      title: '#',
      key: 'index',
      width: 60,
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'รหัสใบแจ้งหนี้',
      dataIndex: 'payment_id',
      key: 'payment_id',
      sorter: (a, b) => a.payment_id?.localeCompare(b.payment_id),
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'วันที่สั่งซื้อ',
      dataIndex: 'createtime',
      key: 'createtime',
      sorter: (a, b) => dayjs(a.createtime).unix() - dayjs(b.createtime).unix(),
      defaultSortOrder: 'descend',
      render: (text) => dayjs(text).format('DD/MM/YYYY HH:mm'),
    },
    {
      title: 'ผู้ซื้อ',
      key: 'buyer',
      sorter: (a, b) => a.buyer_shopname?.localeCompare(b.buyer_shopname),
      render: (_, record) => renderShopInfo(record.buyer_shopname, record.buyer_shopprovince),
    },
    {
      title: 'ยอดรวม',
      dataIndex: 'summary_subtotal',
      key: 'summary_subtotal',
      align: 'right',
      sorter: (a, b) => Number(a.summary_subtotal) - Number(b.summary_subtotal),
      render: renderCurrency,
    },
    {
      title: 'ค่าจัดส่ง',
      dataIndex: 'summary_shipping_markup',
      key: 'summary_shipping_markup',
      align: 'right',
      sorter: (a, b) => Number(a.summary_shipping_markup) - Number(b.summary_shipping_markup),
      render: renderCurrency,
    },
    {
      title: 'ส่วนลด',
      dataIndex: 'summary_discount',
      key: 'summary_discount',
      align: 'right',
      sorter: (a, b) => Number(a.summary_discount) - Number(b.summary_discount),
      render: (val, record) =>
        Number(val || 0) > 0 ? (
          <Space direction='vertical' size={0} style={{ textAlign: 'right' }}>
            <Text type='danger' strong>
              - {formatCurrency(val)}
            </Text>
            {record.coupon_id && (
              <Text type='secondary' style={{ fontSize: '10px' }}>
                🏷️ {record.coupon_id}
              </Text>
            )}
          </Space>
        ) : (
          '-'
        ),
    },
    {
      title: 'ยอดรวมทั้งหมด',
      dataIndex: 'summary_total',
      key: 'summary_total',
      align: 'right',
      sorter: (a, b) => Number(a.summary_total) - Number(b.summary_total),
      render: renderCurrencyBold,
    },
    {
      title: 'จัดการ',
      key: 'action',
      width: 180,
      align: 'center',
      fixed: 'right', // Pinned to right side during horizontal scroll for desktop usability
      render: (_, record) => (
        <Space>
          <Button
            type='primary'
            icon={<EyeOutlined />}
            size='small'
            onClick={() => fetchOrderData(record)}
          >
            รายละเอียด
          </Button>
          <Button icon={<FileImageOutlined />} size='small' onClick={() => fetchSlipImages(record)}>
            สลิป
          </Button>
        </Space>
      ),
    },
  ];

  const paginationConfig = {
    pageSize,
    current: currentPage,
    showTotal: (total) => `รวม ${total} รายการ`,
    onChange: (page, size) => {
      setCurrentPage(page);
      setPageSize(size);
    },
  };

  // Mobile Product Item renders are now handled by MobileProductItem shared component

  const renderShippingInfo = (mypayment) => {
    const shippingOrder = orderList.find((o) => o.payment_id === mypayment.payment_id);
    if (!shippingOrder) return null;

    return (
      <InfoCard title='ที่อยู่จัดส่ง' icon={<EnvironmentOutlined />} variant='success' compact>
        <InfoRow label='ผู้รับ' value={shippingOrder.shipping_recievename} />
        <InfoRow label='เบอร์โทรศัพท์' value={shippingOrder.shipping_telno} />
        <div className='info-row'>
          <Text type='secondary' className='info-row__label'>
            ที่อยู่จัดส่ง
          </Text>
          <div className='info-row__value' style={{ textAlign: 'right', maxWidth: '60%' }}>
            {`${shippingOrder.shipping_address} ${shippingOrder.shipping_district} ${shippingOrder.shipping_state} ${shippingOrder.shipping_province} ${shippingOrder.shipping_postcode}`}
          </div>
        </div>
        <InfoRow label='บริษัทขนส่ง' value={shippingOrder.courier_fullname} />
      </InfoCard>
    );
  };

  const renderPaymentSummary = (mypayment) => (
    <InfoCard title='สรุปยอดชำระ' icon={<DollarOutlined />} variant='success'>
      <InfoRow label='ยอดรวมสินค้า' value={`${formatCurrency(mypayment.summary_subtotal)} ฿`} />
      <InfoRow label='ค่าจัดส่ง' value={`${formatCurrency(mypayment.summary_shipping_markup)} ฿`} />
      {Number(mypayment.summary_discount || 0) > 0 && (
        <InfoRow
          label='ส่วนลด'
          value={`- ${formatCurrency(mypayment.summary_discount)} ฿`}
          valueColor='red'
        />
      )}
      {mypayment.coupon_id && (
        <InfoRow
          label='โค้ดส่วนลดที่ใช้'
          value={
            <Space size={4} wrap>
              {mypayment.coupon_id.split(',').map((c) => (
                <Tag color='cyan' key={c.trim()} style={{ margin: '2px 0' }}>
                  🏷️ {c.trim()}
                </Tag>
              ))}
            </Space>
          }
        />
      )}
      <InfoRow
        label='ยอดสุทธิ'
        value={`${formatCurrency(mypayment.summary_net || mypayment.summary_total)} ฿`}
        bold
        valueColor='green'
      />
    </InfoCard>
  );

  const renderOrderCard = (order, idx) => (
    <InfoCard
      key={order.order_id || idx}
      title={`คำสั่งซื้อ: ${order.order_id}`}
      icon={<ShoppingCartOutlined />}
      variant='success'
      extra={
        <Text type='secondary' style={{ fontSize: '12px' }}>
          ผู้ขาย: {order.seller_shopname}
        </Text>
      }
    >
      {order.orderitem?.map((item, i) => renderProductItem(item, i, order.orderitem.length))}

      <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #f0f0f0' }}>
        <InfoRow label='ยอดรวมสินค้า' value={`${formatCurrency(order.shop_subtotal)} ฿`} />
        <InfoRow label='ค่าจัดส่ง' value={`${formatCurrency(order.shop_shipping_markup)} ฿`} />
        {Number(order.summary_discount || 0) > 0 && (
          <InfoRow
            label='ส่วนลด'
            value={`- ${formatCurrency(order.summary_discount)} ฿`}
            valueColor='red'
          />
        )}
        {order.coupon_id && (
          <InfoRow
            label='โค้ดส่วนลดที่ใช้'
            value={
              <Space size={4} wrap>
                {order.coupon_id.split(',').map((c) => (
                  <Tag color='cyan' key={c.trim()} style={{ margin: '2px 0' }}>
                    🏷️ {c.trim()}
                  </Tag>
                ))}
              </Space>
            }
          />
        )}
        <InfoRow
          label='ยอดรวมทั้งหมด'
          value={`${formatCurrency(order.summary_net || order.shop_total)} ฿`}
          valueColor='green'
          bold
        />
      </div>
    </InfoCard>
  );

  const renderMobileCards = () => {
    return (
      <div className='order-mobile-view'>
        <div className='order-card-container'>
          {payslipList.slice((currentPage - 1) * pageSize, currentPage * pageSize).map((record) => (
            <MobileOrderCard
              key={record.payment_id}
              record={record}
              onViewDetails={fetchOrderData}
              totalClass='success'
              headerExtra={
                <Button
                  type='link'
                  size='small'
                  icon={<FileImageOutlined />}
                  onClick={() => fetchSlipImages(record)}
                >
                  สลิป
                </Button>
              }
            />
          ))}
        </div>
        <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'center' }}>
          <Pagination {...paginationConfig} showSizeChanger={false} size='small' />
        </div>
      </div>
    );
  };

  const renderTable = () =>
    props.isMobile ? (
      renderMobileCards()
    ) : (
      <div className='order-desktop-view'>
        <Table
          columns={columns}
          dataSource={payslipList}
          rowKey='payment_id'
          loading={loading}
          pagination={paginationConfig}
          scroll={{ x: 'max-content' }}
        />
      </div>
    );

  const tabItems = [
    { key: 'pending', label: 'รายการรอตรวจสอบ', children: renderTable() },
    { key: 'history', label: 'ประวัติการตรวจสอบ', children: renderTable() },
  ];

  return (
    <div className='page-wrapper'>
      <div className='page-card'>
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
          <div className='page-header-actions'>
            <div>
              <Title level={3} style={{ margin: 0 }}>
                <FileTextOutlined style={{ color: '#fa8c16', marginRight: '8px' }} />
                ตรวจสอบสลิปการชำระเงิน
              </Title>
              <Text type='secondary'>ตรวจสอบสลิปการชำระเงินทั้งหมดที่ถูกส่งมา</Text>
            </div>
            <Button icon={<ReloadOutlined />} onClick={fetchPaySlipList} loading={loading}>
              รีเฟรช
            </Button>
          </div>

          <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} type='card' />
        </Space>
      </div>

      <Modal
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              width: '95%',
            }}
          >
            <Text strong style={{ fontSize: '18px' }}>
              {currentPayment?.payment_id}
            </Text>
            <div style={{ textAlign: 'right' }}>
              <Text type='secondary' style={{ fontSize: '12px', display: 'block' }}>
                ผู้ขาย: {orderList?.[0]?.seller_shopname || '-'}
              </Text>
            </div>
          </div>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={props.isMobile ? '95%' : 900}
        centered
        className='custom-modal'
      >
        {orderGroup.map((mypayment) => (
          <div
            key={mypayment.payment_id}
            style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
          >
            <InfoCard title='ข้อมูลการชำระ' icon={<CreditCardOutlined />} variant='success' compact>
              <InfoGrid columns={2}>
                <InfoRow label='รหัสชำระ' value={mypayment.payment_id} />
                <InfoRow
                  label='กำหนดชำระ'
                  value={dayjs(mypayment.expiretime).format('DD MMM BBBB HH:mm')}
                />
                <InfoRow
                  label='วิธีการชำระ'
                  value={getPaymentMethodText(mypayment.payment_method)}
                />
                <InfoRow
                  label='สถานะการชำระ'
                  value={
                    activeTab === 'history' || mypayment.api_paymentstatus === 'Success' ? (
                      <Tag color='success' style={{ margin: 0 }}>
                        ได้รับชำระแล้ว
                      </Tag>
                    ) : (
                      <Tag color='warning' style={{ margin: 0 }}>
                        รอตรวจสอบ
                      </Tag>
                    )
                  }
                />
              </InfoGrid>
            </InfoCard>

            <InfoCard
              title={`คำสั่งซื้อ: ${orderList.find((o) => o.payment_id === mypayment.payment_id)?.order_id || '-'}`}
              icon={<ShoppingCartOutlined />}
              variant='success'
            >
              {orderList
                .filter((o) => o.payment_id === mypayment.payment_id)
                .map((order, idx) => (
                  <div key={idx} style={{ marginBottom: idx < orderList.length - 1 ? '16px' : 0 }}>
                    {order.orderitem?.map((item, i) => (
                      <MobileProductItem
                        key={item.productitem_id || i}
                        item={item}
                        idx={i}
                        appHostname={props.app_hostname}
                      />
                    ))}
                  </div>
                ))}
            </InfoCard>

            {renderPaymentSummary(mypayment)}

            {renderShippingInfo(mypayment)}

            <div
              style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '8px' }}
            >
              <Button onClick={() => setIsModalOpen(false)}>ปิดหน้าต่าง</Button>
              {activeTab !== 'history' && mypayment.api_paymentstatus !== 'Success' && (
                <Popconfirm
                  title='ยืนยันการชำระเงิน'
                  description='คุณแน่ใจหรือไม่ที่จะยืนยันว่าได้รับชำระเงินแล้ว?'
                  onConfirm={handleCashReceive}
                  okText='ยืนยัน'
                  cancelText='ยกเลิก'
                >
                  <Button type='primary' danger loading={modalLoading}>
                    ได้รับชำระแล้ว
                  </Button>
                </Popconfirm>
              )}
            </div>
          </div>
        ))}
      </Modal>

      <Image.PreviewGroup
        preview={{
          visible: isGalleryOpen,
          onVisibleChange: (vis) => setIsGalleryOpen(vis),
        }}
      >
        {galleryImages.map((src, index) => (
          <Image key={src || index} src={src} style={{ display: 'none' }} />
        ))}
      </Image.PreviewGroup>
    </div>
  );
};

export default OrderPaySlip;
